<template>
  <div id="upload-point-list">
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button 
                :btn-label="'Upload Points'" 
                @click.native="onClickAddData"
              />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="upload-point-type-status"
                  class="v-select-filter bg-dropdown"
                  placeholder="All Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>
              <div class="search-container mb-1">
                 <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="campaignListTable.payload"
                @sort-changed="sortingChanged"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table text-center "
              >
                <template #cell(seq)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(upload_dt)="data" >
                  <div v-if="data.item.upload_dt != null">
                    <div class="text-center">
                      {{ resolveDateWithSeperator(data.item.upload_dt) }}
                    </div>
                    <div class="text-center">
                      {{ resolveTime(data.item.upload_dt) }}
                    </div>
                  </div>
                </template>
                <template #cell(progress)="data" >
                  <div v-if="data.item.upload_dt != null">
                    <div class="text-center">
                      {{ data.item.progress}} %
                    </div>
                  </div>
                </template>
                <template #cell(status)="data">
                  <div class="d-flex align-items-center justify-content-center">
                    <div
                      class="upload-point-status status-badge  text-center"
                      :class="[resolveClassUploadPointStatus(data.item.status)]"
                    >
                      {{ resolveUploadPointStatus(data.item.status) }}
                    </div>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="text-center">
                    <div class="d-flex status" v-if="data.item.status == 2">
                      <div 
                        class="svg-approve-icon status-circle-wrp approve mr-4"
                        v-b-tooltip.hover.v-success
                        title="Approve"
                        @click="fetchAction(data.item.campaign_id,statusAction.APPROVE)"
                      >
                        <icon-check-svg  class="svg-correct" />
                      </div>
                      <div 
                        class="svg-reject-icon status-circle-wrp reject"
                        v-b-tooltip.hover.v-danger
                        title="Reject"
                        @click="fetchAction(data.item.campaign_id,statusAction.REJECT)"
                      >
                         <icon-cross-svg class="svg-cancel" />
                      </div>
                    </div>
                    <div class="d-flex status align-items-center justify-content-center">
                      <action-group 
                        v-if="data.item.status == 1"
                        :resolve-action="resolveMappingTableAction"
                        :set-action-list="draftActionList"
                        :item-data="data"
                      />
                      <action-group 
                        v-if="data.item.status == 9 || data.item.status == 11"
                        :resolve-action="resolveMappingTableAction"
                        :set-action-list="successActionList"
                        :item-data="data"
                      />
                    </div>
                  </div>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder 
            entity-editable 
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import Sortable from "sortablejs";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useUploadPointList from "@/views/pages/ais-point/upload-point/upload-point-list/hooks/useUploadPointList";
import IconCheckSvg from "@/@core/components/svg/inventory-history-detail/IconCorrect.vue";
import IconCrossSvg from "@/@core/components/svg/inventory-history-detail/IconCancel.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";

const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    OverlayLoading,
    PaginationWithReorder,
    IconCheckSvg,
    IconCrossSvg,
    ActionGroup,
  },
  setup() {
    const {
      loading,
      optionData,
      fields,
      statusOption,
      status,
      statusAction,
      pagination,
      onPageChange,
      onFilterEntity,
      sortingChanged,
      onSetValueSearch,
      onSelectFilter,

      campaignListTable,
      resolveDateWithSeperator,
      resolveTime,
      resolveUploadPointStatus,
      resolveClassUploadPointStatus,
      draftActionList,
      successActionList,
      resolveMappingTableAction,
      fetchAction,
      onClickAddData,
    } = useUploadPointList();

    return {
      loading,
      optionData,
      fields,
      statusOption,
      status,
      statusAction,
      pagination,
      onPageChange,
      onFilterEntity,
      sortingChanged,
      onSetValueSearch,
      onSelectFilter,

      campaignListTable,
      resolveDateWithSeperator,
      resolveTime,
      resolveUploadPointStatus,
      resolveClassUploadPointStatus,
      draftActionList,
      successActionList,
      resolveMappingTableAction,
      fetchAction,
      onClickAddData,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/exchange/ais-point/upload-point.css";
</style>